import React, {forwardRef, useState} from 'react';
import styled from 'styled-components';
import {GenericIconName} from '../Icon/IconName';
import {RatingBackground, RatingContainer, RatingScale} from './styled';

const ratingSteps: number[] = [1, 2, 3, 4, 5];

export interface StarRatingButtonProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  name: string;
  value?: number;
}

const HiddenRadioButton = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0 none;
  opacity: 0;
  z-index: 1;
`;

const StarRatingButton = forwardRef<
  HTMLInputElement,
  Omit<StarRatingButtonProps, 'ref'>
>(function StarRatingButton({value, onChange, className, name, ...rest}, ref) {
  const [ratingValue, setRatingValue] = useState<number>(value ?? 0);

  return (
    <RatingContainer
      className={className}
      {...(rest as any)}
      data-testid={`rating-container-${name}`}
    >
      {ratingSteps.map(val => (
        <RatingScale
          score={val}
          key={val}
          as={'label'}
          fillIcon={GenericIconName.IcStarOutlineBlack}
          onClick={() => {
            setRatingValue(val);
          }}
          // value 1, zIndex = 7
          // value 2, zIndex = 6
          // value 3, zIndex = 5
          // ....
          zIndex={ratingSteps.length - val + 2}
          date-testid={`rating-label-${name}-${val}`}
        >
          <HiddenRadioButton
            onChange={onChange}
            ref={ref}
            type="radio"
            value={val}
            name={name}
            date-testid={`rating-input-${name}-${val}`}
          />
        </RatingScale>
      ))}
      <RatingScale
        score={ratingValue}
        fillIcon={
          ratingValue > 0
            ? GenericIconName.IcStarFillBlack
            : GenericIconName.IcStarFillGray
        }
        date-testid={`rating-fill-${name}-${ratingValue}`}
      />
      <RatingBackground fillIcon={GenericIconName.IcStarOutlineGray} />
    </RatingContainer>
  );
});

export default StarRatingButton;
